import React from 'react';
import LoadingDots from '../LoadingDots';

import styles from '../../assets/styles/colors.scss';
import './LoaderPopup.scss';

export default function LoaderPopup(props) {
  return (
    <div className='loader-popup'>
      <span className='loader-popup__text'>{props.text}</span>
      <LoadingDots color={styles.nonExistant}/>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/LoaderPopup/index.js